import { createFileRoute } from "@tanstack/react-router";
import { AdminOverviewPage } from "@/features/admin/overview";

export const Route = createFileRoute("/admin/")({
  head: () => ({ meta: [{ title: "Overview · Admin · Malfak" }] }),
  component: AdminOverviewPage,
});
